import { FastTrackReview } from "@/components/molecules/fast-track-review";
import { DataTable } from "@/components/molecules/tables/data-table";
import { useServices } from "@/features/services/hooks/use-services";
import { useTranslation } from "@/features/utils/i18n";
import { PageLayout } from "../layout";
import { useServicesBulkActions } from "./components/bulk-actions";
import { useServicesColumns } from "./components/columns";
import { ServiceDialog } from "./components/service-dialog";

export const ServicesListPage = () => {
  const { t } = useTranslation("services");
  const columns = useServicesColumns();
  const bulkActions = useServicesBulkActions();
  const { data: services, isLoading } = useServices();

  return (
    <PageLayout
      title={t("title")}
      description={t("description")}
      actions={<ServiceDialog />}
    >
      <FastTrackReview scope="services" />
      <DataTable
        columns={columns}
        data={services || []}
        isLoading={isLoading}
        hideSearch
        bulkActions={bulkActions}
      />
    </PageLayout>
  );
};
